import { makeStyles } from 'tss-react/mui';

const name = 'FreemiumPlanButton';

export const useFreemiumPlanButtonStyles = makeStyles({ name })(theme => ({
  root: {
    color: theme.palette.primary.main,

    '&&': {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));
